import { QueryClient } from '@tanstack/react-query';

// Shared query client. Defaults tuned for this dashboard: data is considered
// fresh briefly (de-dupes bursts of identical requests), retries once, and
// refetches on window focus so returning to a tab shows current data.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
